/** Persist resolved academy branding so refresh does not flash deploy-time defaults. */
const STORAGE_KEY = 'attendance.branding.v1';

export function readBrandingCache() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') return null;
        return parsed;
    } catch {
        return null;
    }
}

export function writeBrandingCache(data) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch {
        // Private browsing / quota — ignore
    }
}

export function clearBrandingCache() {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch {
        // ignore
    }
}
